/* @flow */

const userRoutes = {
  activity: 'users/:userId/activity',
};

export default userRoutes;
